import {createApp} from '../../../../../vendor/vue/dist/vue.esm-browser.prod.js';
import {get} from "./data-manager";
import docCookies from './../../../../../vendor/doc-cookies';
import Animate from "./animate";

export default class ProjectList {
    constructor($el) {
        this.$el = $el;
        this.createVueApp();
    }

    createVueApp() {
        const blockId = this.$el.dataset.blockId;
        const container = this.$el;

        const app = createApp({
            data() {
                return {
                    blockId: blockId,
                    container: container,
                    projects: [],
                    loader : document.querySelector('[data-loader]'),
                    totalCount: '',
                    category: '',
                    initialized: false,
                    loaded: false
                };
            },
            computed: {
            },
            methods: {
                async fetchProjects()
                {
                    const params = this.getFilters();
                    this.setFiltersInUrl(params);
                    this.setFiltersInCookie(params);
                    const url = `${currentHref}/block/${blockId}/ajax/`;

                    if (this.abortController) {
                        this.abortController.abort();
                    }

                    if(this.loader) {
                        this.loader.classList.add('loader--loading');
                    }

                    this.abortController = new AbortController();
                    const result = await get(url, params, this.abortController.signal);
                    if( ! result) {
                        return;
                    }
                    this.projects = result.publications;
                    this.totalCount = result.totalCount;


                    if(this.loader) {
                        this.loader.classList.remove('loader--loading');
                    }

                    this.loaded = true;
                    this.$nextTick(this.animate)
                },
                animate() {
                    document.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
                },
                /**
                 * Set the current filters in the url
                 * @param filters
                 */
                setFiltersInUrl(filters) {
                    const url = new URL(window.location.href);
                    url.search = (new URLSearchParams(filters)).toString();

                    window.history.pushState({},"", url.toString())
                },
                /**
                 * Set the current filters in the cookie
                 * @param filters
                 */
                setFiltersInCookie(filters) {
                    docCookies.setItem('resto-list-filters', JSON.stringify(filters))
                },
                /**
                 * Get Filters
                 * We get the filters by serializing the form and stripping the empty filters
                 * @returns {{[p: string]: any}}
                 */
                getFilters() {
                    const formData = (new FormData(this.$refs.filters));
                    let filters = Object.fromEntries(formData);

                    // now we remove the empty filters
                    filters = Object.fromEntries(
                        Object.entries(filters).filter(
                            ([filter, value ]) => {
                                if (value) {
                                    return [filter, value];
                                }
                            }
                        )
                    );

                    return filters;
                },
                getFiltersByUrl() {
                    const params = (new URLSearchParams(window.location.search));

                    // if (params.has('page')) {
                    //     this.page = parseInt(params.get('page'));
                    // }

                    // if (params.has('search')) {
                    //     this.search = params.get('search');
                    // }
                },
                getFiltersFromCookie() {
                    const filters = JSON.parse(docCookies.getItem('resto-list-filters'));

                    if(! filters) {
                        return;
                    }

                    // if (filters.page) {
                    //     this.page = parseInt(filters.page);
                    // }

                    // if (filters.search) {
                    //     this.search = filters.search;
                    // }
                },
                /**
                 * Apply Filters
                 * Add a timeout for fetchProducts so we don't spam the backend
                 */
                applyFilters() {
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(this.fetchProjects, 200);
                },
                toggleCategory(e) {
                    this.category =  e.target.dataset.category;
                    this.makeFiltersPassive();
                    this.makeFilterActive(e.target)
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(this.fetchProjects, 200);
                },
                showAll(e) {
                    this.category =  '';
                    this.makeFiltersPassive();
                    this.makeFilterActive(e.target)
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(this.fetchProjects, 200);
                },
                makeFiltersPassive() {
                    this.container.querySelectorAll('[data-filter]').forEach((filter) => {
                        filter.classList.remove('filter--active')
                    })
                },
                makeFilterActive(filter)
                {
                    filter.classList.add('filter--active');
                }
            },
            async mounted() {
                await this.fetchProjects();
                this.initialized = true;
                document.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
            },
            created() {
                if (window.location.search) {
                    this.getFiltersByUrl();
                } else {
                    this.getFiltersFromCookie();
                }
            }
        });

        app.config.compilerOptions.delimiters = ['v{', '}'];

        // mount the app
        app.mount(this.$el);
    }

}